<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>
            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters.name"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.company") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters.plz"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.zipcode") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters.ort"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.city") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['kanton']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.canton") }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="$CONST('CONFIG').APPTYPE != 'DESKA'" class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.firmarolle"
                        :reduce="(fr) => fr.id"
                        :options="firmarollen"
                        label="bezeichnung"
                        :placeholder="$t('global.type')"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.notypefound")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.type") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.status"
                        :reduce="(st) => st.id"
                        :options="stati"
                        label="bezeichnung"
                        :placeholder="$t('global.status')"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.nostatusfound")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.status") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.sprache"
                        :reduce="(st) => st.id"
                        :options="sprachen"
                        label="bezeichnung"
                        :placeholder="$t('global.language')"
                        multiple
                      >
                        <span slot="no-options">{{
                            $t("global.nostatusfound")
                          }}</span>
                      </v-select>
                      <label>{{ $t("global.language") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div class="form-group-inline" style="margin-left: 7px">
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                        >{{ $t("global.onlywithoperation") }}</label
                      ><input
                        class="form-check-input float-right mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters.mitEinsatz"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="filters.mitEinsatz">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.einsatzSaison"
                        :options="saisons"
                        :reduce="(s) => s.id"
                        label="label"
                        :placeholder="$t('global.seasonoperation')"
                      ></v-select>
                      <label>{{ $t("global.seasonoperation") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="filters.mitEinsatz">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.einsatzStatus"
                        :options="einsatzstati"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.operationalstatus')"
                        multiple
                      ></v-select>
                      <label>{{ $t("global.operationalstatus") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" id="number-of-records">
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
                <!--Oder Statement switch-->
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <button
                        class="btn btn-secondary"
                        @click="toggleOrParameter"
                      >
                        {{
                          filters.orStatement
                            ? $t("global.orfilteractive")
                            : $t("global.orfilterinactive")
                        }}
                      </button>
                    </div>
                  </div>
                </div>
                <!--Ende Oder Statement switch-->
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.companiesandfarms')"
              :date="'Mittwoch 29.Juli'"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>

            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <router-link
                      v-if="
                        !rolleProp && berechtigungen.m_geschaeftspartner.create
                      "
                      class="btn btn-success"
                      :to="{
                        name: 'FirmaNewViva',
                        params: { anzeige: 0 },
                      }"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </router-link>

                    <b-dropdown
                      variant="primary ml-2"
                      v-if="berechtigungen.m_korrespondenz.update"
                    >
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-regular fa-envelope"
                          class="mr-2"
                        />
                        {{ $t("global.createmassmail") }}
                      </template>
                      <b-dropdown-item @click="massenmailErstellen(true)">
                        {{ $t("global.selected") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="massenmailErstellen(false)">
                        {{ $t("global.alldisplayed") }}
                      </b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown
                      variant="primary ml-2"
                      v-if="berechtigungen.m_korrespondenz.update"
                    >
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-regular fa-envelope"
                          class="mr-2"
                        />
                        {{ $t("global.createserialletter") }}
                      </template>
                      <b-dropdown-item
                        @click="massenkorrespondenzErstellen(true)"
                      >
                        {{ $t("global.selected") }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="massenkorrespondenzErstellen(false)"
                      >
                        {{ $t("global.alldisplayed") }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <excel-export-modal
                      v-if="berechtigungen.m_geschaeftspartner.read"
                      class="d-inline-block ml-2"
                      :filters="queryParams"
                      :config="excelExportConfig"
                    />
                  </div>
                  <div class="mr-4 float-right">
                    <button
                      class="btn btn-danger"
                      v-if="berechtigungen.m_geschaeftspartner.delete"
                      @click="oeffneLoeschenModal"
                      :disabled="selectedIds.length === 0"
                      :title="
                        selectedIds.length === 0
                          ? $t('global.selectminone')
                          : ''
                      "
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />{{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    sort-icon-left
                    no-local-sorting
                    @sort-changed="sortingChanged"
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' &&
                            field.searchable !== false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                          autocomplete="off"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                    <!-- <template v-slot:cell(name)="row">
                      <div v-if="row.item.abteilungen.length > 0">
                        {{ row.item.name }}
                        <font-awesome-icon
                          v-tooltip.hover="
                            (text =
                              'Abteilungen: <br>' +
                              (row.item.abteilungen
                                ? row.item.abteilungen
                                    .map((abt) => abt?.bezeichnung)
                                    .join('<br>')
                                : ''))
                          "
                          icon="fa-solid  fa-circle-info"
                          class="pl-2 pr-2 pt-1"
                        />
                      </div>
                      <div v-else class="item">
                        {{ row.item.name }}
                      </div>
                    </template> -->

                    <template v-slot:cell(name)="row">
                      <div class="item">
                        {{ row.item.name }}
                      </div>
                    </template>
                  </b-table>
                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">
                      {{ $t("global.loadmorecompanies") }}
                    </div>
                    <div slot="no-more">
                      {{ $t("comapnies.nofurthercompanies") }}
                    </div>
                    <div slot="no-results">
                      {{ $t("global.nofurthercompaniesfound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="firma-loeschen-modal"
      :selectedIds="selectedIds"
      :multiple="true"
      @confirmed="firmaLoeschen"
    />

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayer"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>

    <loading-overlay v-show="loading"></loading-overlay>

    <firmen-dubletten-zusammenfuehren-modal
      id="firmen-dubletten-zusammenfuehren-modal"
      :selectedIds="selectedIds"
      @zusammenfuehrenAbgeschlossen="listeNeuLaden"
    />
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import server from "@/server";
import store from "@/store";
import AppApi from "@/api/AppApi";
import Api from "@/api/Api";

import { LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER } from "@/store/geschaeftspartner/actions.type";
import { LADE_VERSANDLISTEN } from "@/store/korrespondenz/actions.type";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import { saisonOptions, saisonVon, saisonBis } from "@/utils/Saison";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";

import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";

import FirmenDublettenZusammenfuehrenModal from "@/components/crm/FirmenDublettenZusammenfuehrenModal.vue";
import ExcelExportModal from "@/components/Modals/ExcelExportModal.vue";

export default {
  name: "FirmenlisteNewViva",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    FilterSearchResetButton,
    FirmenDublettenZusammenfuehrenModal,
    ExcelExportModal,
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + this.$t("global.navbar_companies");
      },
    };
  },
  mixins: [page, dashboard, filter],
  props: {
    rolleProp: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      sortBy: "firma",
      sortDesc: false,
      pdfPath: "",

      selected: [],
      selectedIds: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "firmanummer",
          sortable: true,
          label: "Nr",
          tdClass: "col-number",
        },
        { key: "name", sortable: true, label: this.$t("global.company") },
        {
          key: "status.bezeichnung",
          sortable: true,
          searchable: false,
          label: this.$t("global.status"),
        },
        {
          key: "email",
          sortable: true,
          label: this.$t("global.email"),
        },
        {
          key: "adresszusatz",
          sortable: true,
          label: this.$t("global.addresssuffix"),
        },
        {
          key: "strasse",
          sortable: true,
          label: this.$t("global.street"),
        },
        {
          key: "plz",
          sortable: true,
          label: this.$t("global.zipcode"),
        },
        {
          key: "ort",
          sortable: true,
          label: this.$t("global.city"),
        },
        {
          key: "kanton",
          sortable: true,
          label: this.$t("global.canton"),
        },
        {
          key: "land",
          sortable: true,
          label: this.$t("global.country"),
        },
      ];
    },
    queryParams: function () {
      var params = {};

      /*  if (this.sortField) {
        params.sdir = this.sortDir;
        params.sfield = this.sortField;
      }

      params.firmenname = this.setQueryParam(this.filters.firmenname);
      params.zip = this.setQueryParam(this.filters.plz);
      params.ort = this.setQueryParam(this.filters.ort);
      params.kanton = this.setQueryParam(this.filters["kanton"]);
      params.firma = this.setQueryParam(this.filters.name);
      params.adresszusatz = this.setQueryParam(this.filters.adresszusatz);
      params.strasse_nr = this.setQueryParam(this.filters.strasse_nr);
      params.land = this.setQueryParam(this.filters.land);
      params.typ = "17EF88469AE";

      params.ip = true;
      params.aec = true;

      params.versand = this.setQueryParamList(this.filters.versand);
      params.interesse = this.setQueryParamList(this.filters.interesse);
      params.firmarolle = this.setQueryParamList(this.filters.firmarolle);

      params.konkordat = this.setQueryParamList(this.filters.konkordat);
      params.orStatement = this.setQueryParam(
        this.filters.orStatement ? "true" : undefined
      );

      params.filterCount = this.setQueryParam(this.filters.count);
      params.mailadresse = this.setQueryParam(
        this.filters["mailadressen[0].bezeichnung"]
      );

      params.nicht_subventioniert = this.setQueryParam(
        this.filters["nicht_subventioniert"]
      );
      params.firmennummer = this.setQueryParam(this.filters.firmennummer); */

      /** Agriviva Filter **/
      params.filterCount = this.setQueryParam(this.filters.count);
      params.filterFirmanummer = this.setQueryParam(this.filters.firmanummer);
      params.filterEmail = this.setQueryParam(this.filters.email);
      params.filterTyp = this.setQueryParamList(this.filters.firmarolle);
      params.filterPLZ = this.setQueryParam(this.filters.plz);
      params.filterOrt = this.setQueryParam(this.filters.ort);
      params.filterKanton = this.setQueryParam(this.filters["kanton"]);
      params.filterFirma = this.setQueryParam(this.filters.name);
      params.filterAdresszusatz = this.setQueryParam(this.filters.adresszusatz);
      params.filterStrasse = this.setQueryParam(this.filters.strasse);
      params.filterLand = this.setQueryParam(this.filters.land);
      params.filterStatus = this.setQueryParamList(this.filters.status);
      params.filterSprache = this.setQueryParamList(this.filters.sprache);

      // Einsatz-Filter: Saison und Status gelten nur zusammen mit "Nur mit Einsatz"
      if (this.filters.mitEinsatz) {
        params.filterMitEinsatz = "true";
        params.filterEinsatzStatus = this.setQueryParamList(this.filters.einsatzStatus);
        params.filterEinsatzVon = saisonVon(this.filters.einsatzSaison);
        params.filterEinsatzBis = saisonBis(this.filters.einsatzSaison);
      }

      return params;
    },
    excelExportConfig() {
      return {
        endpoint: "firmenliste",
        filename: "Firmenliste",
        stichtag: true,
        stichtagHint: "optional – filtert Betriebe mit aktivem Angebot an diesem Datum",
        baseColumns: [
          { key: "firmaNr", label: "Nr." },
          { key: "name",    label: this.$t("global.company") },
          { key: "status",  label: this.$t("global.status") },
          { key: "plz",     label: this.$t("global.zipcode") },
          { key: "ort",     label: this.$t("global.city") },
          { key: "kanton",  label: this.$t("global.canton") },
          { key: "land",    label: this.$t("global.country") },
        ],
        additionalFields: [
          { key: "strasse",               label: this.$t("global.street") },
          { key: "adresszusatz",          label: this.$t("global.addresssuffix") },
          { key: "typ",                   label: this.$t("global.type") + " (je Wert eine Spalte)" },
          { key: "email",                 label: this.$t("global.email") },
          { key: "vermittlungsstelle",    label: this.$t("global.switchboard") },
          { key: "hoflage",               label: "Hoflage" },
          { key: "betriebsgroesse",       label: "Betriebsgrösse (ha)" },
          { key: "bewirtschaftungsarten", label: "Bewirtschaftungsarten (je Wert eine Spalte)" },
          { key: "betriebszweige",        label: "Betriebszweige (je Wert eine Spalte)" },
          { key: "aufgabenbereiche",      label: "Aufgabenbereiche (je Wert eine Spalte)" },
          { key: "tiere",                 label: "Tiere (je Wert eine Spalte)" },
          { key: "datumHofbesuch",        label: "Datum Hofbesuch" },
          { key: "kinderAufHof",          label: "Kinder auf dem Hof" },
          { key: "korrespondenzsprache",  label: "Korrespondenzsprache" },
          { key: "eintrittsdatum",         label: "Eintrittsdatum" },
          { key: "vereinsmitglied",        label: "Vereinsmitglied" },
        ],
        summaryFields: [
          { key: "per_kanton",              label: "Firmen pro Kanton" },
          { key: "per_status",              label: "Firmen pro Status" },
          { key: "per_typ",                 label: "Firmen pro Typ" },
          { key: "per_vs",                  label: "Firmen nach VS" },
          { key: "per_hoflage",             label: "Firmen nach Lage" },
          { key: "per_betriebsgroesse",     label: "Firmen nach Betriebsgrösse" },
          { key: "per_bewirtschaftungsart", label: "Nach Bewirtschaftungsart" },
          { key: "per_betriebszweig",       label: "Nach Betriebszweigen" },
          { key: "per_aufgabenbereich",     label: "Nach Aufgabenbereichen" },
          { key: "per_tier",                label: "Nach Tieren" },
          { key: "per_kinder_auf_hof",      label: "Mit Kindern auf dem Hof" },
          { key: "per_korrespondenzsprache",label: "Nach Korrespondenzsprache" },
        ],
      };
    },

    interessen: {
      get() {
        return this.$store.state.geschaeftspartner.interessen;
      },
    },
    firmarollen: {
      get() {
        return this.$store.state.geschaeftspartner.firma_partnerrollen;
      },
    },
    stati: {
      get() {
        return this.$store.state.geschaeftspartner.aktivitaetsstati;
      },
    },
    saisons() {
      return saisonOptions();
    },
    einsatzstati() {
      return this.$store.state.crm.einsatzstati;
    },
    sprachen: {
      get() {
        return this.$store.state.geschaeftspartner.unterrichtssprachen;
      },
    },
    versandlisten: {
      get() {
        return this.$store.state.korrespondenz.versandlisten;
      },
    },
    konkordate: {
      get() {
        return this.$store.state.geschaeftspartner.konkordate;
      },
    },
  },
  created() {
    if (this.interessen.length == 0)
      this.$store.dispatch(
        `geschaeftspartner/${LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER}`
      );

    if (this.versandlisten.length == 0)
      this.$store.dispatch(`korrespondenz/${LADE_VERSANDLISTEN}`);

    if (this.einsatzstati?.length === 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    this.initFilter("firmaliste", "agriviva-firma/liste/", true);
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
  },
  methods: {
    details(person) {
      this.$router.push({
        name: "FirmaNewViva",
        params: { id: person.id, anzeige: 0 },
      });
    },

    sortingChanged(ctx) {
      this.sortDir = ctx.sortDesc;
      this.sortField = ctx.sortBy;
      this.resetLoading(this);
    },

    toggleOrParameter() {
      if (this.filters.orStatement) {
        this.$set(this.filters, "orStatement", false);
      } else {
        this.$set(this.filters, "orStatement", true);
      }
      this.filterSearch();
    },

    ausgebenAvery365221() {
      let ids = this.selectedIds.join(",");
      let filename = new Intl.DateTimeFormat("ch").format(new Date());

      this.pdfPath =
        server.url +
        `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/firma-avery-3652-21.htm&ids=${ids}`;
      this.$refs.pdfLayer.show();
    },

    ausgebenAvery365314() {
      let ids = this.selectedIds.join(",");
      let filename = new Intl.DateTimeFormat("ch").format(new Date());

      this.pdfPath =
        server.url +
        `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/firma-avery-3653-14.htm&ids=${ids}`;
      this.$refs.pdfLayer.show();
    },

    /*ausgebenZweckform478427() {
      let ids = this.selectedIds.join(",");
      let filename = new Intl.DateTimeFormat("ch").format(new Date());

      this.pdfPath =
        server.url +
        `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/firma-zweckform-4784-27.htm&ids=${ids}`;
      this.$refs.pdfLayer.show();
    },*/

    massenmailErstellen(selected) {
      if (!selected || this.selectedIds.length > 0) {
        let tempList = selected
          ? this.selectedIds
          : this.$refs.selectableTable.items.map((item) => item.id);

        let json = {
          firma: tempList,
          isMassMail: true,
          inhalt: "",
          zeitpunkt: new Intl.DateTimeFormat("ch").format(new Date()),
        };

        Api.post("mail/", json, { params: {} }).then((response) => {
          this.$router.push({
            name: "mail",
            params: {
              id: response.data.id,
              anzeige: 0,
            },
          });
        });
      } else
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonsselected"),
        });
    },

    massenkorrespondenzErstellen(selected) {
      if (!selected || this.selectedIds.length > 0) {
        let tempList = selected
          ? this.selectedIds
          : this.$refs.selectableTable.items.map((item) => item.id);

        let json = {
          empfaenger: [],
          firma: [], // ist de facto person. Noch unsauber im Backend
          isMassKorrespondenz: true,
          versand: {
            erstelltvon: this.angemeldeterMitarbeiter.person,
            datum: new Intl.DateTimeFormat("ch").format(new Date()),
            ort: this.$CONST("CONFIG").MANDANTSTADT,
            betreff: "",
          },
          inhalt: "",
          zeitpunkt: new Intl.DateTimeFormat("ch").format(new Date()),
        };

        json.empfaenger = tempList;
        json.firma = tempList;

        Api.post("korrespondenz/", json, { params: {} }).then((response) => {
          Api.post("korrespondenz/empfaenger/", json, {
            params: {
              korrespondenz: response.data.id,
              isFirma: true,
              isMassCorr: true,
            },
          }).then((empfresponse) => {}),
            this.$router.push({
              name: "korrespondenz",
              params: {
                id: response.data.id,
                anzeige: 0,
              },
            });
        });
      } else
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonselected"),
        });
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0) console.log(this.selectedIds);
      this.$bus.$emit("openLoeschenModal", "firma-loeschen-modal");
    },

    firmaLoeschen() {
      AppApi.delete("agriviva-firma/maske/", {
        data: this.selectedIds,
      }).then(() => {
        this.resetLoading(this);
      });
    },
    oeffneFirmenDublettenZusammenfuehrenModal() {
      this.$bus.$emit("open-modal", "firmen-dubletten-zusammenfuehren-modal");
    },
    listeNeuLaden() {
      this.resetLoading(this);
    },
  },
};
</script>

<style></style>
